import { EyeSlashIcon } from "@heroicons/react/24/solid";
import React, { useState } from "react";

const HideButton = ({ buttonText, onClick, className }) => {
  const [disable, setDisable] = useState(false);
  return (
    <button
      disabled={disable}
      onClick={onClick}
      className={`hover:scale-90 bg-gray-600 shadow-md h-6  lg:h-6 lg:px-2 w-20 lg:w-21 text-white font-base hover: hover:bg-opacity-75 h flex flex-row items-center justify-around text-xs-1 border rounded-full px-px py-1 m-1 transition duration-500 ease select-none focus:outline-none focus:shadow-outline undefined cursor-pointer ${className}`}
    >
      <EyeSlashIcon className="h-4 w-4 sm:-mr-4 lg:-mr-2" />
      <div>{buttonText}</div>
    </button>
  );
};
export default HideButton;
